import type { useMerchantSettings } from "@/api/admin/merchant-risks";
import { formatDate } from "@/utils/date-conversion";

type MerchantSettings = NonNullable<ReturnType<typeof useMerchantSettings>["data"]>;

const InfoField = ({ label, value }: { label: string; value: string }) => (
  <div>
    <span className="text-xs text-tertiary block">{label}</span>
    <span className="text-sm text-primary">{value}</span>
  </div>
);

export const MerchantInfo = ({ settings }: { settings: MerchantSettings }) => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
    {settings.vertical && <InfoField label="Vertical" value={settings.vertical} />}
    {settings.merchantTiktokUsername && <InfoField label="TikTok Username" value={settings.merchantTiktokUsername} />}
    {settings.onboardingTime && <InfoField label="Onboarding Date" value={formatDate(settings.onboardingTime)} />}
    {settings.brandNames.length > 0 && <InfoField label="Merchant Names" value={settings.brandNames.join(", ")} />}
    {settings.productNames.length > 0 && <InfoField label="Product Names" value={settings.productNames.join(", ")} />}
  </div>
);
